import { render, staticRenderFns } from "./PurchaserMapping.vue?vue&type=template&id=7ae78847&"
import script from "./PurchaserMapping.vue?vue&type=script&lang=js&"
export * from "./PurchaserMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports